import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, ref, watch } from 'vue';
import { StorageService } from '@/core';
import CheckoutService from '@/services/checkout.service';
import { injectParentValidator } from '@/core/app.service';
import { store } from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AlternativeDeliveryForm',
  props: {
    model: null,
    deliveryMethod: null,
    value: null,
    taxCalculationErrorMessage: null
  },
  emits: ["input", "changeTaxField", "updateShippingCountry"],
  setup(__props: any, { emit }: { emit: ({(e: 'input', value: ShippingAddress): void,
    (e: 'changeTaxField'): void,
    (e: 'updateShippingCountry', value: AddressCountryViewObject): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    model: CheckoutPageViewModel,
    deliveryMethod: DeliveryMethodViewObject,
    value?: ShippingAddress,
    taxCalculationErrorMessage?: string,
 }



const basket = computed<BasketViewModel>(() => store.getters['basket/basket']);
const form = ref<ShippingAddress>(props.value);


const phoneRegex = /^[+]{0,1}[- +0-9]*$/;

const selectedShippingCountry = ref<AddressCountryViewObject>({} as AddressCountryViewObject);
const selectedShippingState = ref<StateViewObject>({} as StateViewObject);

const isNonUSDelivery = computed(() => selectedShippingCountry.value.countryCode !== 'US');

// Inject validator
injectParentValidator();

const postalCodeRegex = computed(() => {
    if (selectedShippingCountry.value.countryCode) {
        return props.model.invoiceAddressCountries.find(x => x.id === selectedShippingCountry.value.countryCode).postalCodeRegex;
    }

    return (props.model.invoiceAddressCountries && props.model.invoiceAddressCountries[0] && props.model.invoiceAddressCountries[0].postalCodeRegex ? props.model.invoiceAddressCountries[0].postalCodeRegex : '');
});

function onShippingCountryChanged(country : AddressCountryViewObject) {
    const deliveryInfo = Object.assign(form.value, { countryCode: country.countryCode });

    emit('input', deliveryInfo);
    emit('updateShippingCountry', country);
    setDeliveryInfoInLocalStorage(deliveryInfo);
}

function setDeliveryInfoInLocalStorage(value: ShippingAddress) {
    StorageService.setItemAs(CheckoutService.deliveryInfoLocalStorageKey, value);
}

onMounted(setSelectedCountryAndState);

const states = computed(() => {
    if (selectedShippingCountry.value.countryCode) {
        return props.model.countryStates.find(x => x.country === selectedShippingCountry.value.countryCode).states;
    }

    return props.model.countryStates.find(x => x.country === props.model.invoiceAddressCountries[0].id).states;
});

function setSelectedCountryAndState() {
    if (props.model.shippingAddressCountries.length === 1) {
        selectedShippingCountry.value = props.model.shippingAddressCountries[0];
    } else {
        selectedShippingCountry.value = props.model.shippingAddressCountries.find(c => c.countryCode === form.value.countryCode);
    }

    selectedShippingState.value = props.model.countryStates.find(x => x.country === selectedShippingCountry.value.countryCode).states.find(c => c.code === form.value.extendedFields.stateCode);
}

watch(() => props.value, onDeliveryInfoChange, { deep: true });

function onDeliveryInfoChange() {
    form.value = props.value;
    emit('input', form.value);
    setSelectedCountryAndState();
}

function onShippingStateChanged(state: StateViewObject) {
    const deliveryInfo = Object.assign(form.value, { extendedFields: Object.assign(form.value.extendedFields, { stateCode: state.code }) });

    emit('input', deliveryInfo);
    setDeliveryInfoInLocalStorage(deliveryInfo);
    emit('changeTaxField');
}

function blur() {
    setDeliveryInfoInLocalStorage(form.value);
}

function getShippingAddressCountries(model: CheckoutPageViewModel) : AddressCountryViewObject[] {
    return model.shippingAddressCountries;
}

function isShippingCountryDropdownDisabled(model: CheckoutPageViewModel) : boolean {
    return model.shippingAddressCountries.length <= 1;
}


return { __sfc: true,props, basket, form, emit, phoneRegex, selectedShippingCountry, selectedShippingState, isNonUSDelivery, postalCodeRegex, onShippingCountryChanged, setDeliveryInfoInLocalStorage, states, setSelectedCountryAndState, onDeliveryInfoChange, onShippingStateChanged, blur, getShippingAddressCountries, isShippingCountryDropdownDisabled }
}

})